import { render, staticRenderFns } from "./SubscriberNumbering.vue?vue&type=template&id=b52ca9d6&scoped=true&"
import script from "./SubscriberNumbering.vue?vue&type=script&lang=js&"
export * from "./SubscriberNumbering.vue?vue&type=script&lang=js&"
import style0 from "./SubscriberNumbering.vue?vue&type=style&index=0&id=b52ca9d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52ca9d6",
  null
  
)

export default component.exports